import React, {FC, useEffect, useMemo, useState} from 'react'
import Select from 'react-select'
import {KTCard} from '../../../../../../../../_metronic/helpers'
import {KTable, KTableHeader, KTableLoading} from '../../../../../../components/UI'
import {KTableProvider, useKTable} from '../../../../../../contexts/KTableProvider'
import {SnackbarProvider} from 'notistack'
import {Column} from 'react-table'
import {useCentral} from '../../../../../../hooks/useCentral'
import {
  ParameterCostModelDocument,
  ParameterRange,
  UpdateCostDto,
} from '../../../../model/parameter.model'
import {
  getListCostService,
  getListRangesService,
  getParameterByIdService,
  updateCostsService,
  getListTypesService,
} from '../../../../services/parameter.service'
import {ModalUpdateCosts} from '../modal/ModalUpdateCost'
import {ShowSnackBar} from '../../../../../../util/functions'

const EditableCell = React.memo(
  ({
    columnId,
    value,
    onChange,
    disabled,
  }: {
    columnId: string
    value: number
    disabled: boolean
    onChange: (event: React.ChangeEvent<HTMLInputElement>, row: any) => void
  }) => (
    <input
      type='number'
      name={columnId}
      value={value}
      onChange={onChange as any}
      onFocus={(event) => event.target.select()}
      step='0.01'
      onKeyPress={(event) => {
        if (event.key === 'Enter') {
          event.preventDefault()
        }
      }}
      disabled={disabled}
      style={{
        width: '100%',
        border: 'none',
        backgroundColor: '#eff2f5',
        height: '40px',
        textAlign: 'center',
      }}
    />
  ),
)

const EditSelectableCell = React.memo(
  ({
    columnId,
    value,
    onChange,
    disabled,
    data,
  }: {
    columnId: string
    value: any
    data: any
    disabled?: boolean
    onChange: (event: any, row: any) => void
  }) => (
    <Select
      key={columnId}
      className='react-select-container'
      classNamePrefix='react-select'
      placeholder='Selecciona una opción'
      options={data}
      noOptionsMessage={() => 'No hay resultados'}
      value={data?.find((c: {value: string}) => c.value === value)}
      onChange={onChange}
      isDisabled={disabled}
    />
  ),
)

const TableCosts: FC = () => {
  const {data, setData, setPagination, loading, setLoading, pagination} = useKTable()
  const {currentTabItem, isAllowed} = useCentral()
  const [showModal, setShowModal] = useState(false)
  const [itemToEdit, setItemToEdit] = useState({})
  const [infoEdit, setInfoEdit] = useState<any>('Lavandería')
  const [valApp, setValApp] = useState<any>('Lavandería')
  const [status, setStatus] = useState<any>('')
  const [code, setCode] = useState<any>('')
  const [typeService, setTypeService] = useState<any[]>([])
  const [ranges, setRanges] = useState<{[key: string]: string}>({})
  const getCosts = async () => {
    setLoading(true)
    const {data: response} = await getListCostService(currentTabItem.idToEdit)
    if (!response.error) {
      setData(response.data)
      setPagination({
        ...pagination,
        totalResults: response.total,
      })
    }
    setLoading(false)
  }

  const getTypeService = async (siteId: string, campId: string) => {
    try {
      const {
        data: {data},
      } = await getListTypesService({
        SiteId: siteId,
        CampamentoId: campId,
      })
      const mappedData = data.map((item: any) => ({
        value: item.TipoServicioId,
        label: item.TipoServicioNombre,
      }))

      setTypeService([{value: '', label: 'Selecciona una opción'}, ...mappedData])
    } catch (error) {}
  }
  const getClaimId = async () => {
    try {
      const {idToEdit} = currentTabItem
      if (idToEdit) {
        const {
          data: {data},
        } = await getParameterByIdService(idToEdit as any)
        const {
          Codigo,
          AplicacionId,
          Aplicacion_descripcion,
          EstadoParametros_descripcion,
          SiteId,
          CampamentoId,
        } = data
        getTypeService(SiteId, CampamentoId)
        setValApp(AplicacionId)
        setCode(Codigo)
        let module =
          Aplicacion_descripcion === 'Lavandería'
            ? 'Tipo de Ropa'
            : Aplicacion_descripcion === 'Hotelería'
            ? 'Tipo de Habitacion'
            : 'Tipo Servicio'
        setInfoEdit(module)
        setStatus(EstadoParametros_descripcion)
      }
    } catch (error) {}
  }

  useEffect(() => {
    setLoading(loading)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading])

  useEffect(() => {
    getClaimId()
    getCosts()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabItem.idToEdit])

  useEffect(() => {
    setLoading(false)
    getCosts()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination.currentPage])

  const getDescriptionsR = async () => {
    try {
      const response = await getListRangesService(
        currentTabItem.objectInfo.aplicacionId,
        currentTabItem.objectInfo.RangoCabId,
      )
      const data = (response.data.data as ParameterRange[]) || []
      const obj: {[key: string]: string} = {}

      data.forEach((item: ParameterRange) => {
        obj[item.Codigo] = item.Descripcion
      })
      setRanges(obj)
    } catch (error) {}
  }

  useEffect(() => {
    getDescriptionsR()
  }, [])

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, row: any) => {
    // Actualiza el valor directamente en el estado de la tabla
    const newData = data.length === 0 ? [{}] : [...data]
    newData[row.index][event.target.name] = Number(event.target.value) || 0
    setData(newData)
  }

  const handleSelectChange = (event: any, row: any) => {
    const name = 'tipoServicioComensalRefId'
    const val = event
    const newData = data.length === 0 ? [{}] : [...data]
    newData[row.index][name] = val.value
    setData(newData)
  }
  const handleEdit = async () => {
    const newArray: UpdateCostDto[] = []
    const {data: response} = await getListCostService(currentTabItem.idToEdit)
    const ini: any[] = response.data
    for (let i = 0; i < data.length; i++) {
      const TipoHabitacionId = data[i]?.TipoHabitacionId
      let tieneCambios = false

      for (let j = 0; j <= 50; j++) {
        const rango = `R${j}`
        const value = data[i][rango]
        const oldValue = ini[i][rango]

        if (value !== oldValue) {
          tieneCambios = true
          let item: UpdateCostDto = {}
          if (currentTabItem.objectInfo.aplicacion === 'Hotelería') {
            item = {
              ParamFacturacionCabId: currentTabItem.idToEdit,
              TipoHabitacionId,
              RangoCodigo: rango,
              Costo: value,
              TipoRopaId: '',
            }
          }
          if (currentTabItem.objectInfo.aplicacion === 'Lavandería') {
            item = {
              ParamFacturacionCabId: currentTabItem.idToEdit,
              TipoHabitacionId: '',
              RangoCodigo: rango,
              Costo: value,
              TipoRopaId: TipoHabitacionId,
            }
          }
          if (currentTabItem.objectInfo.aplicacion === 'Comedores') {
            item = {
              ParamFacturacionCabId: currentTabItem.idToEdit,
              TipoServicioComensalId: TipoHabitacionId,
              TipoServicioComensalRefId: data[i]['tipoServicioComensalRefId'],
              RangoCodigo: rango,
              Costo: value,
              TipoRopaId: null,
              TipoHabitacionId: null,
            }
          }
          newArray.push(item)
        }
      }

      if (
        !tieneCambios &&
        currentTabItem.objectInfo.aplicacion === 'Comedores' &&
        data[i]['tipoServicioComensalRefId'] !== ini[i]['tipoServicioComensalRefId']
      ) {
        let itemSinCambio: UpdateCostDto = {
          ParamFacturacionCabId: currentTabItem.idToEdit,
          TipoServicioComensalId: TipoHabitacionId,
          TipoServicioComensalRefId: data[i]['tipoServicioComensalRefId'],
          RangoCodigo: 'R0',
          Costo: data[i]['R0'],
          TipoRopaId: null,
          TipoHabitacionId: null,
        }
        newArray.push(itemSinCambio)
      }
    }
    setLoading(true)

    let errorEdit = false
    let errorMessage = ''
    for (let j = 0; j < newArray.length; j++) {
      try {
        if (errorEdit) break
        const {data: res} = await updateCostsService(newArray[j])
        if (res.error) {
          errorEdit = true
          errorMessage = res.message
        }
      } catch (error) {
        console.log(error)
      }
    }
    if (errorEdit) {
      ShowSnackBar(errorMessage, 'error')
    } else {
      ShowSnackBar('Se han actualizado los costos correctamente')
    }
    getCosts()
  }

  const columns: Column<any>[] = useMemo(() => {
    const baseColumns: Column<any>[] = [
      {
        Header: (props) => <KTableHeader tableProps={props} title={infoEdit} />,
        accessor: 'TipoHabitacionNombre',
      },
    ]
    const selectColumn: Column<any>[] = [
      {
        Header: (props) => (
          <KTableHeader tableProps={props} title={'Referencia'} className='min-w-200px' />
        ),
        accessor: 'tipoServicioComensalRefId',
        Cell: ({...props}) => {
          return (
            <EditSelectableCell
              columnId={props.column.id}
              value={props.row.original.tipoServicioComensalRefId}
              data={typeService}
              onChange={(event) => handleSelectChange(event, props.row)}
            />
          )
        },
      },
    ]
    const rangeColumns: Column<any>[] = Array.from({length: 51}, (_, index) => ({
      Header: (props) => (
        <KTableHeader tableProps={props} title={`R${index} (${ranges[`R${index}`] || ''})`} />
      ),
      accessor: `R${index}`,
      Cell: ({...props}) => (
        <EditableCell
          columnId={props.column.id}
          value={props.value}
          disabled={!isAllowed('COSTO/EDITAR') || status !== 'PENDIENTE'}
          onChange={(event) => handleInputChange(event, props.row)}
        />
      ),
    }))

    return [...baseColumns, ...(valApp === '*v1dvu1gtmQ=' ? selectColumn : []), ...rangeColumns]
  }, [typeService, ranges, infoEdit])
  return (
    <>
      {isAllowed('COSTO/LISTAR') && (
        <KTCard shadow className='m-5 h-100'>
          <div className='d-flex justify-content-end p-2 me-5'>
            {isAllowed('COSTO/EDITAR') && status === 'PENDIENTE' && (
              <button type='button' className='btn btn-success me-3' onClick={handleEdit}>
                Editar Costos
              </button>
            )}
          </div>
          <div
            className='d-flex justify-content-start p-2 ms-5 me-5 font-size-base '
            style={{
              fontWeight: '600',
            }}
          >
            Código tarifario: {code}
          </div>
          <KTable data={data} columns={columns as any}/>
          {loading ? <KTableLoading title='Cargando...' /> : null}
          {showModal ? (
            <ModalUpdateCosts
              show={showModal}
              setShow={setShowModal}
              itemToEdit={itemToEdit}
              getCosts={getCosts}
            />
          ) : (
            <></>
          )}
          <SnackbarProvider />
        </KTCard>
      )}
    </>
  )
}

const TableCostsWrapper = () => {
  return (
    <KTableProvider>
      <TableCosts />
    </KTableProvider>
  )
}

export {TableCostsWrapper}
